export const countriesBranchMap: Record<string, string> =
    {
        "AD": "fed",
        "AE": "fae",
        "AF": "fed",
        "AG": "fed",
        "AI": "fed",
        "AL": "fed",
        "AM": "fed",
        "AN": "fed",
        "AO": "fae",
        "AQ": "fed",
        "AR": "fed",
        "AS": "fed",
        "AT": "fed",
        "AU": "fed",
        "AW": "fed",
        "AX": "fed",
        "AZ": "fed",
        "BA": "fed",
        "BB": "fed",
        "BD": "fae",
        "BE": "fed",
        "BF": "fae",
        "BG": "fbg",
        "BH": "fae",
        "BI": "fae",
        "BJ": "fed",
        "BL": "fed",
        "BM": "fed",
        "BN": "fed",
        "BO": "fed",
        "BQ": "fed",
        "BR": "fed",
        "BS": "fed",
        "BT": "fed",
        "BV": "fed",
        "BW": "fae",
        "BY": "fed",
        "BZ": "fed",
        "CA": "fed",
        "CC": "fed",
        "CD": "fed",
        "CF": "fed",
        "CG": "fae",
        "CH": "fed",
        "CI": "fae",
        "CK": "fed",
        "CL": "fed",
        "CM": "fae",
        "CN": "fed",
        "CO": "fed",
        "CR": "fed",
        "CU": "fed",
        "CV": "fed",
        "CW": "fed",
        "CX": "fed",
        "CY": "fed",
        "CZ": "fed",
        "DE": "fed",
        "DJ": "fed",
        "DK": "fed",
        "DM": "fed",
        "DO": "fed",
        "DZ": "fae",
        "EC": "fed",
        "EE": "fed",
        "EG": "fae",
        "EH": "fed",
        "ER": "fed",
        "ES": "fed",
        "ET": "fae",
        "FI": "fed",
        "FJ": "fed",
        "FK": "fed",
        "FM": "fed",
        "FO": "fed",
        "FR": "fed",
        "GA": "fae",
        "GB": "fed",
        "GD": "fed",
        "GE": "fed",
        "GF": "fed",
        "GG": "fed",
        "GH": "fae",
        "GI": "fed",
        "GL": "fed",
        "GM": "fae",
        "GN": "fae",
        "GP": "fed",
        "GQ": "fed",
        "GR": "fed",
        "GS": "fed",
        "GT": "fed",
        "GU": "fed",
        "GW": "fed",
        "GY": "fed",
        "HK": "fed",
        "HM": "fed",
        "HN": "fed",
        "HR": "fbg",
        "HT": "fed",
        "HU": "fed",
        "IC": "fed",
        "ID": "fed",
        "IE": "fed",
        "IL": "fed",
        "IM": "fed",
        "IN": "fae",
        "IO": "fed",
        "IQ": "fae",
        "IR": "fae",
        "IS": "fed",
        "IT": "fed",
        "JE": "fed",
        "JM": "fed",
        "JO": "fae",
        "JP": "fed",
        "KE": "fae",
        "KG": "fed",
        "KH": "fed",
        "KI": "fed",
        "KM": "fed",
        "KN": "fed",
        "KP": "fed",
        "KR": "fed",
        "KW": "fae",
        "KY": "fed",
        "KZ": "fed",
        "LA": "fed",
        "LB": "fae",
        "LC": "fed",
        "LI": "fed",
        "LK": "fae",
        "LR": "fae",
        "LS": "fed",
        "LT": "fed",
        "LU": "fed",
        "LV": "fed",
        "LY": "fae",
        "MA": "fae",
        "MC": "fed",
        "MD": "fed",
        "ME": "fed",
        "MF": "fed",
        "MG": "fae",
        "MH": "fed",
        "MK": "fed",
        "ML": "fae",
        "MM": "fed",
        "MN": "fed",
        "MO": "fed",
        "MP": "fed",
        "MQ": "fed",
        "MR": "fae",
        "MS": "fed",
        "MT": "fed",
        "MU": "fae",
        "MV": "fae",
        "MW": "fae",
        "MX": "fed",
        "MY": "fed",
        "MZ": "fae",
        "NA": "fae",
        "NC": "fed",
        "NE": "fae",
        "NF": "fed",
        "NG": "fae",
        "NI": "fed",
        "NL": "fed",
        "NO": "fed",
        "NP": "fae",
        "NR": "fed",
        "NU": "fed",
        "NZ": "fed",
        "OM": "fae",
        "PA": "fed",
        "PE": "fed",
        "PF": "fed",
        "PG": "fed",
        "PH": "fae",
        "PK": "fae",
        "PL": "fed",
        "PM": "fed",
        "PN": "fed",
        "PR": "fed",
        "PS": "fed",
        "PT": "fed",
        "PW": "fed",
        "PY": "fed",
        "QA": "fae",
        "RE": "fed",
        "RO": "fed",
        "RS": "fbg",
        "RU": "fed",
        "RW": "fae",
        "SA": "fae",
        "SB": "fed",
        "SC": "fae",
        "SD": "fae",
        "SE": "fed",
        "SG": "fed",
        "SH": "fed",
        "SI": "fbg",
        "SJ": "fed",
        "SK": "fed",
        "SL": "fae",
        "SM": "fed",
        "SN": "fae",
        "SO": "fae",
        "SR": "fed",
        "SS": "fed",
        "ST": "fed",
        "SV": "fed",
        "SX": "fed",
        "SY": "fae",
        "SZ": "fed",
        "TC": "fed",
        "TD": "fed",
        "TF": "fed",
        "TG": "fae",
        "TH": "fed",
        "TJ": "fed",
        "TK": "fed",
        "TL": "fed",
        "TM": "fed",
        "TN": "fed",
        "TO": "fed",
        "TR": "fae",
        "TT": "fed",
        "TV": "fed",
        "TW": "fed",
        "TZ": "fae",
        "UA": "ukr",
        "UG": "fae",
        "UM": "fed",
        "US": "fed",
        "UY": "fed",
        "UZ": "fed",
        "VA": "fed",
        "VC": "fed",
        "VE": "fed",
        "VG": "fed",
        "VI": "fed",
        "VN": "fae",
        "VU": "fed",
        "WF": "fed",
        "WS": "fed",
        "XC": "fed",
        "XI": "fed",
        "XK": "fed",
        "XM": "fed",
        "YE": "fae",
        "YT": "fed",
        "ZA": "fae",
        "ZM": "fae",
        "ZW": "fae"
    }